<template>
  <a-modal title="创建数据库" :width="600" :visible="visible" :confirmLoading="confirmLoading" @cancel="handleCancel">
    <a-spin :spinning="confirmLoading">
      <div v-if="false">
        <a-form :form="form">
          <a-alert
            :closable="true"
            type="info"
            showIcon
            message="该操作将会创建新数据库并覆盖原有数据库信息，请谨慎操作！"
            style="margin-bottom: 24px"
          />
          <a-form-item label="数据库主机" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input v-decorator="['host', { rules: [{ required: true, message: '必填项' }] }]" placeholder="请填写" />
          </a-form-item>
          <a-form-item label="数据库端口" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input v-decorator="['port', { rules: [{ required: true, message: '必填项' }] }]" placeholder="请填写" />
          </a-form-item>
          <a-form-item label="数据库用户名" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input
              v-decorator="['username', { initialValue: 'root', rules: [{ required: true, message: '必填项' }] }]"
              placeholder="请填写root"
            />
          </a-form-item>
          <a-form-item label="数据库密码" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input
              v-decorator="['password', { rules: [{ required: true, message: '必填项' }] }]"
              placeholder="请填写"
            />
          </a-form-item>
        </a-form>
      </div>
    </a-spin>
    <template slot="footer">
      <a-button @click="handleCancel">取消</a-button>
      <a-button :loading="confirmLoading" type="primary" @click="handleSubmit">确定</a-button>
    </template>
  </a-modal>
</template>

<script>
import DeviceApi from '@/api/device'
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      },
      mdl: {},
      currentRobotId: '',
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
    }
  },
  methods: {
    ...mapGetters(['userInfo']),
    show (currentRobotId) {
      this.currentRobotId = currentRobotId
      this.visible = true
    },
    handleCancel () {
      this.visible = false
    },
    handleSubmit (e) {
      e.preventDefault()
      this.confirmLoading = true
      const main_id = this.userInfo().id
      const sub_id = this.currentRobotId
      DeviceApi.saveDbInit({
        sub_id: sub_id,
        main_id: main_id,
        host: '******',
        port: '******',
        username: '******',
        password: '******'
      })
        .then(res => {
          if (res.code === 1) {
            this.form.resetFields()
            this.$message.success('创建数据库成功')
            this.visible = false
            this.$emit('ok')
          } else {
            this.$message.error(res.msg)
          }
        })
        .finally(() => {
          this.confirmLoading = false
        })
    }
  }
}
</script>
<style lang="less" scoped>
.database-ascription {
  display: flex;
  justify-content: space-evenly;
  margin-bottom: 24px;
  text-align: center;
  .ant-radio-button-wrapper {
    width: 100%;
  }
}
</style>
